import { Component, OnInit } from '@angular/core';
import {
  EnterpriseBasketService,
  EvolviTrainSeatMap,
  UserService,
  WithSubscriptionComponent
} from '@sabstravtech/obtservices/angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faSeatAirline } from '@fortawesome/pro-regular-svg-icons';
import { clone } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-evolvi-seatmap-modal',
  templateUrl: './evolvi-seatmap-modal.component.html',
  styleUrl: './evolvi-seatmap-modal.component.scss',
  standalone: false
})
export class EvolviSeatmapModalComponent extends WithSubscriptionComponent implements OnInit {
  faSeatAirline = faSeatAirline;
  seatMaps: EvolviTrainSeatMap[] = [];
  chosenSeats = {};
  defaultChosenSeats = {};
  tmcName = '';
  reservedSeats = null;
  key = null;
  selectedIndices = {};
  basketItem = null;
  schema = null;
  haveChosenSeats = false;
  atLeastOneChosenSeat = false;
  maxSeats = 1;
  releventLegs = {};

  constructor(
    public readonly dialogRef: NgbActiveModal,
    private basketService: EnterpriseBasketService,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit(): void {
    const allLegs = this.basketItem.detail.outbound.journeyLegs.concat(
      this.basketItem.detail.return ? this.basketItem.detail.return.journeyLegs : []
    );

    for (const seatmap of this.seatMaps) {
      const relevantLeg = allLegs.find((leg) => leg.id === (seatmap as any).legId);
      this.releventLegs[relevantLeg.id] = relevantLeg;
    }

    this.maxSeats = this.basketItem.users.length + this.basketItem.guests.length;

    this.defaultChosenSeats = clone(this.chosenSeats) || {};

    this.reservedSeats.forEach((seat) => {
      const relevantSeatMap = this.seatMaps.find(
        (seatmap) => (seatmap as any).legId === seat.legId
      );

      if (relevantSeatMap) {
        const index = relevantSeatMap.coaches.findIndex((coach) => coach.id === seat.coach);
        this.selectedIndices[seat.legId] = index;
      }
    });

    this.tmcName = this.userService.getfullUserDetails().userData.value.tmc_name;
    this.setSeatControls();
  }

  resetSeat() {
    this.basketService.chosenEvolviSeat.next(null);
  }

  chooseSeat(chosen: any) {
    // console.log('+++ New Chosen Seat: ', chosen);

    if (!this.chosenSeats[chosen.legId]) {
      this.chosenSeats[chosen.legId] = [];
    }

    if (chosen.chosenSeat?.length) {
      // clear out all entries with that coach and replace with this
      this.chosenSeats[chosen.legId] = this.chosenSeats[chosen.legId].filter(
        (choice) => choice.coach !== chosen.chosenCoach.id
      );

      chosen.chosenSeat.forEach((seat) => {
        this.chosenSeats[chosen.legId].push({ seat, coach: chosen.chosenCoach.id });
      });
    } else {
      // clear out all entries with that coach and replace with this
      this.chosenSeats[chosen.legId] = this.chosenSeats[chosen.legId].filter(
        (choice) => choice.coach !== chosen.chosenCoach.id
      );
    }

    // console.log(this.chosenSeats);
  }

  setSeatControls() {
    const keys = Object.keys(this.chosenSeats);
    if (keys.length === this.seatMaps.length) {
      this.haveChosenSeats = true;
    } else {
      this.haveChosenSeats = false;
    }

    if (!keys.length) {
      this.atLeastOneChosenSeat = false;
    } else {
      this.atLeastOneChosenSeat = true;
    }
  }
}
LightningModalTypes.EvolviSeatmapModalComponent.component = EvolviSeatmapModalComponent;
